import instance from "./apiClient";
import { apiRoutes } from "configs/apiRoutes";

export type ProfileDataStatus = "approved" | "pending" | "missing";

export interface ProfileDataField {
  fieldKey: string;
  value: unknown;
  status: ProfileDataStatus;
}

export interface ProfileDataVerification {
  status: ProfileDataStatus;
  configured: boolean;
  canApprove: boolean;
  fields: ProfileDataField[];
}

export interface VerificationCapability {
  capability: string;
  status: string;
  required: boolean;
}

export interface VerificationState {
  overallStatus: string;
  isKycConfirmed: boolean;
  capabilities: VerificationCapability[];
}

interface RequirementsResponse {
  data: { fields: string[] };
}

interface ProfileDataResponse {
  data: ProfileDataVerification;
}

interface VerificationStateResponse {
  data: VerificationState;
}

interface ApproveResponse {
  data: Record<string, never>;
}

export const getProfileDataRequirements = () =>
  instance.get<RequirementsResponse>(
    apiRoutes.verificationProfileDataRequirements,
  ) as unknown as Promise<RequirementsResponse>;

export const getProfileDataVerification = (userId: number) =>
  instance.get<ProfileDataResponse>(
    apiRoutes.verificationProfileData(userId),
  ) as unknown as Promise<ProfileDataResponse>;

export const getVerificationState = (userId: number) =>
  instance.get<VerificationStateResponse>(
    apiRoutes.verificationState(userId),
  ) as unknown as Promise<VerificationStateResponse>;

export const approveProfileData = (userId: number) =>
  instance.post<ApproveResponse>(apiRoutes.approveVerification(userId), {
    capability: "profileData",
  }) as unknown as Promise<ApproveResponse>;
